export default "__VITE_ASSET__54254414__"